import { render, staticRenderFns } from "./DataAnalyst.vue?vue&type=template&id=6d78aaca&scoped=true&"
import script from "./DataAnalyst.vue?vue&type=script&lang=js&"
export * from "./DataAnalyst.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalyst.vue?vue&type=style&index=0&id=6d78aaca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d78aaca",
  null
  
)

export default component.exports